import React, { memo, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { ParamsAndReturnTypes } from '@prisjakt/ui-translate/src/translate-func';
import StockStatus from '@prisjakt/ui-stock-status';
import Tooltip from '@prisjakt/ui-tooltip-new';

import { StockStatusStates } from '@prisjakt/ui-stock-status/src/types';
import { ProductPriceType } from '../../../../areas/product/types';
import { Price } from '../../../../types';

import PriceNotice from '../price-notice';

import * as S from './styles';

type OwnProps = {
  className?: string;
  status?: StockStatusStates | null;
  statusText?: string | null;
  toneDown?: boolean;
  countryCode?: string | null;
  isInternationalPrice?: boolean;
  showTooltip?: boolean;
  priceType?: ProductPriceType | null;
  deliveryOptions?: Price['deliveryOptions'];
  width?: number;
};

const StockStatusColumn = ({
  className,
  status,
  statusText,
  toneDown = false,
  countryCode,
  isInternationalPrice = false,
  showTooltip = true,
  priceType,
  deliveryOptions = [],
  width,
}: OwnProps) => {
  const { t, market } = useContext(AppContext);
  const processedStatusText = statusText
    ? statusText.replace(/-/g, '\u2011') /* no-breaking hyphen in dates */
    : t(
        'product',
        `stock-status.${status ||
          'unknown'}` as keyof ParamsAndReturnTypes['product']
      );

  const homeDelivery =
    deliveryOptions &&
    deliveryOptions.find(option => option && option.type === 'HOME_DELIVERY');

  return (
    <div className={className}>
      {homeDelivery && (
        <Tooltip
          placement="left"
          wrapperWidth={25}
          title={t(
            'product',
            `home-delivery.info` as keyof ParamsAndReturnTypes['product']
          )}
          renderOnMouseOver
        >
          <S.HomeDeliveryIcon
            src={`${market.cdn}/rfe/g/home-delivery.e5660c.svg`}
          />
        </Tooltip>
      )}
      {priceType && priceType !== ProductPriceType.NORMAL ? (
        <Tooltip
          placement="left"
          title={t(
            'product',
            `price-notice.${priceType}` as keyof ParamsAndReturnTypes['product']
          )}
          renderOnMouseOver
        >
          <PriceNotice
            type={priceType as NonNullable<ProductPriceType>}
            hideText
          />
        </Tooltip>
      ) : null}
      {countryCode && (
        <S.CountryFlag
          show={isInternationalPrice}
          countryCode={countryCode}
          title={t(
            'common',
            `market.${countryCode}` as keyof ParamsAndReturnTypes['common']
          )}
        />
      )}
      <S.StockStatusWrapper toneDown={toneDown} alignCenter>
        <StockStatus
          classicIcons
          status={status}
          showText={false}
          toneDown={toneDown}
          tooltip={showTooltip ? (processedStatusText as string) : ''}
          width={width}
        />
      </S.StockStatusWrapper>
    </div>
  );
};

export default memo(StockStatusColumn);
